export const silenSoundShowcase = {
    init: () => {
        console.debug("silenSoundShowcase.js: init");
        /*
        Setup the page
        */
        $(".js-play-video-data-id-1").attr("data-id", "1")
        $(".js-play-video-data-id-2").attr("data-id", "2")
        $(".js-play-video-data-id-3").attr("data-id", "3")
        $(".js-play-video-data-id-4").attr("data-id", "4")

        $(".product-features-alt__col-video").html(`<button type="button" class="product-features-alt__col-video-toggle-sound" data-sound="off">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="16" cy="16" r="16" fill="#F7F7F7" fill-opacity="0.7"></circle>
                <rect x="7.82324" y="18.2782" width="4.51429" height="5.46467"
                    transform="rotate(-90 7.82324 18.2782)" fill="#ffffff"></rect>
                <path
                    d="M15.9002 9.48701L15.9002 22.088L15.9002 22.5547L10.4355 17.4952L10.4355 14.5465L15.9002 9.48701Z"
                    fill="#ffffff"></path>
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M17.5654 21.0105C20.2319 21.0105 22.4361 18.7475 22.4361 15.9022C22.4361 13.0569 20.2319 10.794 17.5654 10.794L17.5654 9.60599C20.9351 9.60599 23.6241 12.449 23.6241 15.9022C23.6241 19.3555 20.9351 22.1985 17.5654 22.1985L17.5654 21.0105Z"
                    fill="#ffffff"></path>
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M17.5654 16.6491C17.9778 16.6491 18.3122 16.3147 18.3122 15.9023C18.3122 15.4899 17.9778 15.1556 17.5654 15.1556L17.5654 13.2888C19.0088 13.2888 20.179 14.4589 20.179 15.9023C20.179 17.3457 19.0088 18.5159 17.5654 18.5159L17.5654 16.6491Z"
                    fill="#ffffff"></path>
                <rect class="icon-sound-off" x="6.39844" y="7.57446" width="1.66316" height="25.1026"
                    transform="rotate(-45 6.39844 7.57446)" fill="#ffffff"></rect>
            </svg>
        </button>` + $(".product-features-alt__col-video").html());

        /*
        USED IN 118-silent-spaces.html
        We have recived this as a example from Silen to showcase the audio levels in a booth
        */
        $(document).on('click', '.product-features-alt__col-video-toggle-sound, .video-wrap__toggle-sound', function () {
            var $el = $(this);
            var sound = $el.attr('data-sound');
            var soundStatus = 'off';
            var muted = true;
            var timeout = 0;

            if (sound === 'off') {
                soundStatus = 'on';
            }
            $el.attr('data-sound', soundStatus);

            if (soundStatus === 'on') {
                muted = false;
                timeout = 50;
            }

            if ($el.is('.product-features-alt__col-video-toggle-sound')) {
                setTimeout(function () {
                    $el.parent().find('video.is-active').get(0).muted = muted;
                }, timeout);
            }

            if ($el.is('.video-wrap__toggle-sound')) {
                setTimeout(function () {
                    $el.parent().find('video').get(0).muted = muted;
                }, timeout);
            }
        });

        /**
         * Play video
         */
        function playVideoWithControls($el, id) {
            var muted = true;
            var sound = $el.closest('.product-features-alt__col-video-wrap').find('.product-features-alt__col-video-toggle-sound').attr('data-sound');
            var $wrap = $el.closest('.product-features-alt__col-video-wrap');
            var $currentVideo = $wrap.find('.product-features-alt__col-video-in video:nth-child(' + id + ')');

                $wrap.find('.product-features-alt__col-video-in video:nth-child(' + id + ')').prevAll('video').each(function () {
                    var $video = $(this);
                    $video.get(0).pause();
                });
                $wrap.find('video:nth-child(' + id + ')').nextAll('video').each(function () {
                    var $video = $(this);
                    $video.get(0).pause();
                });
                setTimeout(function () {
                    $currentVideo.get(0).play();
                }, 50);

                setTimeout(function () {
                    if (sound === 'on') {
                        muted = false;
                    }
                    $currentVideo.get(0).muted = muted;
                }, 100);
            

            $wrap.find('video').removeClass('is-active');
            $currentVideo.addClass('is-active');
        }


        $(document).on('click', '.js-play-video', function () {
            var $el = $(this);
            $('video').trigger('play');
            $('.js-play-video').removeClass('is-active');
            $el.addClass('is-active');
            playVideoWithControls($(this), $(this).attr('data-id'));
        });

        setTimeout(function () {
            $('video.is-active').trigger('play');
        }, 4000);



        var video = document.querySelectorAll('video');

        // Add source to video tag
        function addSourceToVideo(element, src) {
            var source = document.createElement('source');
            source.src = src;
            source.type = 'video/mp4';
            element.appendChild(source);
        }

        // Determine screen size and select mobile or desktop vid
        function whichSizeVideo(element, src) {
            var windowWidth = window.innerWidth ? window.innerWidth : $(window).width();
            var video = src.dataset.desktopVid;

            if (windowWidth <= 767) {
                if (src.dataset.mobileVid) {
                    video = src.dataset.mobileVid;
                }
            }

            addSourceToVideo(element, video);
        }

        // Init only if page has videos
        function videoSize() {
            if (video !== undefined) {
                video.forEach(function (element, index) {
                    whichSizeVideo(
                        element, // element
                        element  // src locations
                    );
                });
            }
        }
        videoSize();

    },

}